import { Site } from '@/models/Site';
import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { SiteListState } from './state';

export const getters: GetterTree<SiteListState, RootState> = {
    getListValue(state): Site[] {
        return state.siteList;
    },
    getCurrentPage(state): number {
        return state.page;
    },
    getNumberOfPages(state): number {
        return state.pages;
    },
    getError(state): boolean {
        return state.error;
    },
    getIsLoading(state): boolean {
        return state.isLoading;
    },
    getFilter(state): string {
        return state.filter;
    },
    getScroll(state): number {
        return state.scroll;
    },
    getSiteId(state): number {
        return state.siteId;
    }
};
